<div class="skeleton-main" [ngStyle]="{ height: height, width: width }">
    <div class="skeleton-left">
        <div
            *ngFor="let i of [].constructor(skeletonCount); let index = index"
            class="skeleton h15 mb20"
            [ngClass]="'w' + skeletonWidthsLeft[index % skeletonWidthsLeft.length]"
        ></div>
    </div>
    <div class="skeleton-right">
        <div
            *ngFor="let i of [].constructor(skeletonCount); let index = index"
            class="skeleton h15 mb20"
            [ngClass]="'w' + skeletonWidthsRight[index % skeletonWidthsRight.length]"
        ></div>
    </div>
</div>
